import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import { IoIosClose } from "react-icons/io";

const ViewModal = ({ id, title, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  var result = data.find((item) => item.id === id);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openZoomModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeZoomModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  const renderImage = (image, i) => {
    return (
      <img
        className="inline-flex border rounded-md border-gray-100 dark:border-gray-600 w-24 max-h-24 p-2"
        src={process.env.REACT_APP_API_IMAGE_URL + image}
        alt="Preview"
      />
    );
  };
  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
   .custom-modal {
 
  overflow-y-auto; /* Enable scrolling if the content overflows */
}
    
    `;

  const amenitiesMapping = {
    1: "AC",
    2: "Charger",
    3: "Music",
    4: "Carrier",
    5: "TV",
    6: "First Aid Kit",
  };

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white w-1/2 rounded-md"
        isOpen={isViewModalOpen}
        onClose={() => {
          closeModal();
        }}
      >
        <ModalBody className="custom-modal" style={{ margin: "0" }}>
          <div className="flex items-center justify-between  px-4 py-2">
            <h2 className="flex-1 text-center text-lg font-bold">
              Vehicle Category Details
            </h2>

            <button
              type="button"
              onClick={closeModal}
              className="ml-4 text-xl font-bold text-gray-500 hover:text-red-500 dark:text-gray-300"
            >
              ×
            </button>
          </div>

          <div
            className="flow-root   py-3 shadow-sm overflow-y-auto"
            style={{ maxHeight: "600px", scrollbarWidth: "thin" }}
          >
            <dl className="rounded-lg border border-gray-200 text-sm dark:text-white ml-5 mr-5 mb-5 ">
              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-white">
                  Vehicle Category
                </dt>
                <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20 ">
                  {result?.vehicle_type_name || "-"}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-white">
                  Similar Vehicle
                </dt>
                {/* <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                  {result?.similar_vehicle}
                </dd> */}

                <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                  {result?.vehicle_names?.map((item, index) => (
                    <span key={index}>
                      {item}
                      {index < result.vehicle_names.length - 1 && ", "}
                    </span>
                  ))}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-white">
                  Seats
                </dt>

                <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                  {result?.seats || "-"}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-white">
                  Bags
                </dt>
                <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                  {result?.no_of_bags || "-"}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-white">
                  Image
                </dt>

                <dd
                  className="text-gray-700 dark:text-white sm:col-span-2 pl-20"
                  onClick={() => openZoomModal(result?.image)}
                >
                  {result && Array.isArray(result?.image) && (
                    <>
                      {result?.image.map((image, i) => renderImage(image, i))}
                    </>
                  )}

                  {result && result?.image && renderImage(result?.image)}
                </dd>
              </div>

              {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                  <div className="bg-white dark:bg-gray-600 p-4 rounded-lg max-w-md w-full relative">
                    <button
                      onClick={closeZoomModal}
                      className="viewModelBoxCloseBtn bg-white dark:bg-gray-600 dark:text-white"
                    >
                      <IoIosClose />
                    </button>

                    <img
                      src={process.env.REACT_APP_API_IMAGE_URL + selectedImage}
                      alt="Driver"
                      className="w-full h-auto rounded-lg"
                    />
                  </div>
                </div>
              )}

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-white">
                  Amenities
                </dt>
                <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                  {result?.amenities
                    ?.map((amenity) => amenitiesMapping[amenity])
                    .join(", ")}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-white">
                  Prime Available
                </dt>
                <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                  {result?.is_prime === true ? "Yes" : "No"}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-white">
                  Prime Benefits
                </dt>
                <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                  {result?.benefits || "-"}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-white">
                  Prime Image
                </dt>

                <dd
                  className="text-gray-700 dark:text-white sm:col-span-2 pl-20"
                  onClick={() => openZoomModal(result?.prime)}
                >
                  {result && Array.isArray(result?.prime) && (
                    <>
                      {result?.prime.map((image, i) => renderImage(image, i))}
                    </>
                  )}

                  {result && result?.prime && renderImage(result?.prime)}
                </dd>
              </div>
            </dl>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
